import { cn } from 'lib/helpers/utility';

import Button from '../Button/Button';
import Popover from '../Popovers/Popover/Popover';

/**
 * @param {import('./lib/propTypes').InputOptionsProps} props
 */

const InputOptions = ({
  options = [],
  currentOption = null,
  onClickOption,
  position = 'bottom',
  className,
  panelClassName,
  disabled
}) => {
  return (
    <Popover
      isFixed
      isDropdown
      icon={false}
      position={position}
      disabled={disabled}
      text={currentOption}
      optionActiveIcon={null}
      options={options.map((option) => ({
        ...option,
        className: 'text-center h-[30px]'
      }))}
      onOptionClick={(option) => onClickOption(option?.value)}
      dataQa="popover-open"
      className={cn(
        'flex items-center !rounded-[4px] bg-neutral-100  hover:bg-neutral-200',
        className
      )}
      textClassName="text-neutral-600"
      panelClassName={cn('min-w-16', panelClassName)}
      customButtonTrigger={({ open }) => (
        <Button
          variant="tertiary"
          iconClassName={cn('transition-transform duration-200', open && 'rotate-180')}
          iconRight="chevron-down-linear"
          size="xs"
          disabled={disabled}
          text={currentOption}
        />
      )}
    />
  );
};

export default InputOptions;
